import { AolValidationItem } from '../../../types/ViewModel/AolItem';
import { reportTypeString } from '../../../utils/aolSectionHelper';
import { ErrorContentRow, ErrorEventsWrapper } from '../aol-main/AolMain.style';
import React from 'react';
import usePostUpdateAolSection from '../../../api/usePostUpdateAolSection';
import { prettifyHours } from 'odfjell-date-time-utils/dateTimeFormatter';

type Props = {
    aolValidationItems: AolValidationItem[] | null | undefined;
};

const AolValidationMismatchComponent: React.FC<Props> = ({ aolValidationItems }) => {
    const { syncAolPortLogHoursMismatch, syncNoonReportImosPortCallIdMismatch } = usePostUpdateAolSection();

    const AolValidationMismatches = () => {
        if (!aolValidationItems) return <div>There is a mismatch between the selected AOL and reported events. Please delete the current AOL.</div>;

        const validationItems = aolValidationItems.map((v, i) => {
            const data = v.data as any;

            if (v.type === 'imosPortCallId') {
                return (
                    <ErrorContentRow key={`validation_imosPortCallId_${i}`}>
                        Some changes have been detected in the rotation. Please accept to synchronize
                        <button onClick={() => syncNoonReportImosPortCallIdMismatch(v.noonReport, data.portLogPortCallId)}>Accept</button>
                    </ErrorContentRow>
                );
            }
            if (v.type === 'numberOfHours') {
                return (
                    <ErrorContentRow key={`numberOfHours${i}`}>
                        Hours have been adjusted in this report. Please review and adjust the consumption if needed. AOL (
                        {prettifyHours(data.noonReportHours)}), events ({prettifyHours(data.portLogHours)})
                        <button onClick={() => syncAolPortLogHoursMismatch(v.noonReport, data.portLogHours)}>Accept</button>
                    </ErrorContentRow>
                );
            }
            if (v.type === 'noonReportType') {
                return (
                    <ErrorContentRow key={`noonReportType${i}`}>
                        The report type for the selected AOL ({reportTypeString(data.noonReportType)}) is not in sync with the reported events (
                        {reportTypeString(data.portLogType)}). Please delete the selected AOL or review the reported events.
                    </ErrorContentRow>
                );
            }
            if (v.type === 'missingPortLogAolItem') {
                return (
                    <ErrorContentRow key={`noonReportType${i}`}>
                        The selected AOL is connected to deleted events. Please delete this AOL.
                    </ErrorContentRow>
                );
            }
            return <></>;
        });

        return <div className="error-row">{validationItems}</div>;
    };

    return (
        <>
            <ErrorEventsWrapper>
                <h3>AOL and reported events mismatch</h3>
                {AolValidationMismatches()}
            </ErrorEventsWrapper>
        </>
    );
};

export default AolValidationMismatchComponent;
